import useNotification from '../Notification'

export const handleContactCreateErrors = async (response) => {
    if (response.data.details?.email) {
        useNotification(
            "Ops!",
            response.data.details?.email[0].description,
            "danger"
        )
        return
    }

    let defaultError = "Ocorreu um erro no sistema"

    if (response.data?.error && response.data?.contact) {
        const name = response.data.contact.owner_name ? response.data.contact.owner_name : "Público"
        defaultError = "Este contato já existe e pertence à outra pessoa."
    }
    else if (response.data?.error?.pop() === "Enter a valid email address."){
        defaultError = "Utilize um e-mail válido."
    }
    else if (response.status == 400) {
        const errorMessages = {
            "Invalid data type. Expected an integer."    : "deve conter um número.",
            "Invalid data type. Expected either 0 or 1." : "deve conter Sim ou Não.",
        }
        Object.keys(response.data).forEach((key) => {
            response.data[key].forEach((error) => {
                if (errorMessages[error])
                    defaultError = `O campo ${key} ${errorMessages[error]}`;
            });
        })
    }
    else if (response.status === 406) {
        defaultError = "Limite de contatos atingido. Contate o seu gerente comercial."
    }
    else if (response.status === 405)
        defaultError = "Você não pode criar contatos."

    useNotification("Ops!", defaultError, "danger")
}
